// extracted by mini-css-extract-plugin
module.exports = {"tagSelect":"tagSelect___3--08","expanded":"expanded___l39_3","trigger":"trigger___2umXY","hasExpandTag":"hasExpandTag___2Sdrl"};